import * as React from 'react';
import { IEstoSlice3Config } from '../../DetailComponent/EstoSlice3/EstoSlice3Option';
import { ISwatchConfig } from '../Configurator';
import CartWrapper from '../../CartWrapper';
import CartButton from '../../CartButton';
import BuyBackDetail from 'components/BuyBack/BuyBackDetail';
import BuyBackModal from 'components/BuyBack/BuyBackModal';
import FinanceCalculator from 'components/Financing/FinanceCalculator';
import { HTML_CLASSES } from '../../../../../constants/product.constants';
import { empty } from '../../../../../helpers/empty';
import { useProductContext } from '../../../../../contexts/ProductContext';
import { CartType } from 'components/Cart/Enum/CartType';
import useLastRegularOrSlice from 'components/Cart/Hooks/useLastRegularOrSlice';
import SmartdealB2BButton from 'components/SmartdealB2B/SmartdealB2BButton';
import { IInbankRentalFitModalLabels } from '../../InbankRentalCartButtonOverlay';

export const AddToCartSection: React.FC = () => {
    const {
        price,
        oldPrice,
        selectedProductInformation,
        productConfig,
        cartFlowType,
        setCartFlowType,
        slice3MethodEnabled,
        slice3Config,
        setSlice3Config,
        estoSlice3Config,
        inbankRentalEnabled,
        inbankRentalConfig,
        swatchConfig,
        buyBackConfig,
        financialConfig,
        smartdealB2BConfig,
        disablePurchase,
        buyBackProducts,
        setBuyBackProducts,
        skipBuyBack,
        setSkipBuyBack,
        addBuyBackProducts,
        setAddBuyBackProducts,
        savedBuyBackProducts,
        addToCart,
        addToCartInbankRental,
        addBuyBackProductsReq,
        inbankRentalData,
        setInbankRentalData,
    } = useProductContext();

    const [lastRegularOrSlice, setLastRegularOrSlice] = useLastRegularOrSlice();
    if (!selectedProductInformation.isAvailable) {
        return <div className={HTML_CLASSES.LABEL_NOTICE}>{productConfig.notAvailableLabel || ''}</div>;
    }

    return (
        <React.Fragment>
            <CartWrapper
                cartFlowType={cartFlowType}
                setCartFlowType={setCartFlowType}
                slice3MethodEnabled={slice3MethodEnabled}
                slice3Config={slice3Config}
                setSlice3Config={setSlice3Config}
                estoSlice3Config={estoSlice3Config || ({} as IEstoSlice3Config)}
                inbankRentalEnabled={inbankRentalEnabled}
                price={price}
                oldPrice={oldPrice}
                monthlyFee={inbankRentalConfig?.monthlyFee}
                inbankRentalLabels={inbankRentalConfig?.inbankRentalLabels}
                aboutInbankRental={inbankRentalConfig?.aboutInbankRental}
                inbankRentalTermsUrl={inbankRentalConfig?.inbankRentalTermsUrl}
                productId={selectedProductInformation?.productId || productConfig.id}
                productConfig={productConfig}
                selectedProductInformation={selectedProductInformation}
                swatchConfig={swatchConfig || ({} as ISwatchConfig)}
                useInsuranceLabel={inbankRentalConfig?.useInsuranceLabel}
                extraInfo={inbankRentalConfig?.extraInfo}
                onInbankRentalDataChange={setInbankRentalData}
            />
            {buyBackConfig && (
                <>
                    <BuyBackDetail
                        buyBackConfig={buyBackConfig}
                        setSkipBuyBack={setSkipBuyBack}
                        setAddBuyBackProducts={setAddBuyBackProducts}
                        skipBuyBack={skipBuyBack}
                        addBuyBackProducts={addBuyBackProducts}
                        buyBackProducts={buyBackProducts}
                    />
                    <BuyBackModal
                        config={buyBackConfig}
                        buyBackProducts={buyBackProducts.map((buyBackProduct) => {
                            buyBackProduct.unique_id = `${buyBackProduct.model_id}${Math.random()}`;
                            return buyBackProduct;
                        })}
                        setBuyBackProducts={(buyBackProducts) => setBuyBackProducts([...buyBackProducts])}
                        saveCallback={(newBuyBackproducts) => {
                            if (savedBuyBackProducts && savedBuyBackProducts.length > 0 && newBuyBackproducts) {
                                void addBuyBackProductsReq(newBuyBackproducts);
                            }
                        }}
                        resetCallBack={() => {
                            if (savedBuyBackProducts) {
                                setBuyBackProducts(savedBuyBackProducts);
                            }
                        }}
                    />
                </>
            )}
            <div className={HTML_CLASSES.PRODUCT_CTA}>
                <CartButton
                    buttonConfig={productConfig.addToCartButton}
                    productId={selectedProductInformation?.productId || productConfig.id}
                    isInbankRentalAdd={cartFlowType === CartType.INBANK_RENTAL_CART}
                    isSlice3Add={cartFlowType === CartType.SLICE3_CART}
                    isEstoSlice3Add={cartFlowType === CartType.ESTO_SLICE3_CART}
                    isEstoSlice3ValidationError={false}
                    isInbankRentalOverlay={true}
                    addToCart={() => void addToCart()}
                    addToCartInbankRental={() => void addToCartInbankRental()}
                    productConfig={productConfig}
                    selectedProductInformation={selectedProductInformation}
                    swatchConfig={swatchConfig}
                    slice3ModalLabels={slice3Config?.modalLabels}
                    isSliceValidationError={slice3Config?.isSliceValidationError}
                    setCartFlowType={setCartFlowType}
                    lastRegularOrSlice={lastRegularOrSlice}
                    setLastRegularOrSlice={setLastRegularOrSlice}
                    disablePurchase={disablePurchase()}
                    timeToRenew={inbankRentalData?.timeToRenew ? parseInt(inbankRentalData.timeToRenew, 10) : undefined}
                    notSamePrioritySkus={inbankRentalData?.notSamePrioritySkus ?? []}
                    isHero={inbankRentalData?.isHero ?? false}
                    cartHeroProducts={inbankRentalData?.cartHeroProducts ?? undefined}
                    inbankRentalFee={inbankRentalData?.monthlyFee || inbankRentalConfig?.monthlyFee}
                    inbankRentalModalFitLabels={
                        (inbankRentalData?.modalLabels as unknown) as IInbankRentalFitModalLabels
                    }
                />
            </div>
            {inbankRentalEnabled &&
                smartdealB2BConfig.enabled &&
                (selectedProductInformation.sku || productConfig.sku.value) && (
                    <SmartdealB2BButton
                        config={smartdealB2BConfig}
                        sku={selectedProductInformation.sku || productConfig.sku.value}
                    />
                )}
            {financialConfig && (
                <FinanceCalculator
                    config={financialConfig}
                    productId={
                        !empty(productConfig.isConfigurableProduct)
                            ? selectedProductInformation.productId
                            : productConfig.id
                    }
                />
            )}
        </React.Fragment>
    );
};
